import Vue from 'vue'
import VueRouter from 'vue-router'
import _Login from '../views/login/login.vue';
import print from '../components/print.vue'
import Set from '../components/set.vue'
import report from '../components/report.vue'
import printManage from '../components/printManager.vue'
import {
	logout,setGUID
} from '../store/router.js'
import {
	LogIn,
	setInservet
} from '../store/router.js'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Login',
		components: {
			default: _Login,
		},
	},
]
console.log(process.env.BASE_URL)
const router = new VueRouter({
	mode: 'history',
	base: '/',//process.env.BASE_URL,Web/
	//scrollBehavior after having new route,choose where scroll to
	routes
})
//login cookie
router.beforeEach((to, from, next) => {
	
	// setGUID();
	console.log('route====',to)
	if(to=='/cgy'){
		setTimeout(()=>{
			window.location.href="/cgy.html";
		},0);
		
	}else
		next()
});

export default router
